const state = {
  all: [],
  invoices: [],
  vouchers: [],
  statusList: [],
  isLoading: false,
  isPaginating: false,
  inProgress: false,
  inXLSProgress: false,
  commentLoading: false,
  hasEmpty: false,
  filter: {
    page: 1,
    reference_number: null,
    mainStatus: null,
    status: null,
    transporter_name: null,
    lr_number: null,
    invoice_number: null,
    gst_type: null,
    note_type: null,
    date_range: null,
  },
  transporterAll: [],
  customFields: [],
  returnFields: [],
  invoice: {},
  extractFirstPayment: {},
  extractTax: {},
  paymentUpdatedDates: [],
  comments: [],
  selectedInvoiceType: { id: 0, name: 'All Invoices' },
};

export default state;
